import React from 'react'
import Divider from 'redesign/components/atoms/Divider'
import RadioFormGroup from 'redesign/components/molecules/RadioFormGroup'
import { useAbsenceTenantSelection } from './hooks/use-absence-tenant-selection'
import type { AbsenceTenantSelectionProps } from './types'

const AbsenceTenantSelection: React.FC<AbsenceTenantSelectionProps> = ({
  formFields,
  formErrors,
  modulePersonIds,
  getTenantOptions,
  handlePersonUuidChange,
}) => {
  const { tenantSelectionError, displayTenantSelection, options, selectedValue, setSelectedValue, t } =
    useAbsenceTenantSelection({
      formFields,
      formErrors,
      modulePersonIds,
      getTenantOptions,
      handlePersonUuidChange,
    })

  return displayTenantSelection ? (
    <>
      <RadioFormGroup
        error={Boolean(tenantSelectionError)}
        legend={t('absenceRequest.new.personUuid.label')}
        options={options}
        setSelectedValue={setSelectedValue}
        selectedValue={selectedValue}
      />
      <Divider />
    </>
  ) : null
}

export default AbsenceTenantSelection
